"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutStorage = void 0;
const tslib_1 = require("tslib");
const LocalStorageManager_1 = require("../../javascript/LocalStorageManager");
const Utilities_1 = require("../../javascript/Utilities");
const FieldNameConverter_1 = require("./FieldNameConverter");
class _StorageKeyCache {
    static set(options, storageKey) {
        const cacheKey = _StorageKeyCache.getCollayoutOptionsKey(options);
        if (cacheKey && storageKey)
            _StorageKeyCache.m_storageKeyCache[cacheKey] = storageKey;
    }
    static get(options) {
        const cacheKey = _StorageKeyCache.getCollayoutOptionsKey(options);
        if (cacheKey)
            return _StorageKeyCache.m_storageKeyCache[cacheKey];
    }
    static getCollayoutOptionsKey(options) {
        if (!options)
            return "";
        let keyComponents = [];
        if (options.parentId) {
            keyComponents.push("parentId=" + options.parentId);
            if (options.relId)
                keyComponents.push("relId=" + options.relId.toString());
        }
        else {
            if (options.layoutName)
                keyComponents.push("ln=" + options.layoutName);
            if (options.catIdDependent)
                keyComponents.push("catDep=true");
            if (options.windowNameDependent)
                keyComponents.push("winDep=true");
            if (typeof options.catId !== "undefined")
                keyComponents.push("cat=" + options.catId.toString());
        }
        return keyComponents.join(";");
    }
}
_StorageKeyCache.m_storageKeyCache = {};
class LayoutStorage {
    static getLayoutAsync(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const serverLayout = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("CollLayout"),
                requestData: JSON.stringify(options)
            });
            _StorageKeyCache.set(options, serverLayout.storageKey);
            // Needed for refreshing collayouts on language change
            const ui = Utilities_1.synUtil.UserInfo.getUserInfo();
            const langId = parseInt(ui.UILanguageId, 10);
            serverLayout.langid = langId;
            const localLayoutJson = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Layout, serverLayout.storageKey);
            const localLayout = localLayoutJson != undefined ? JSON.parse(localLayoutJson).layoutJSON : undefined;
            if (localLayout && localLayout.langid === serverLayout.langid) {
                LayoutStorage.migrateColumnFormat(localLayout, false);
                if (localLayout.etag === serverLayout.etag)
                    return localLayout;
            }
            LayoutStorage.migrateColumnFormat(serverLayout, false);
            LayoutStorage.SaveLayout(serverLayout.storageKey, serverLayout);
            return serverLayout;
        });
    }
    static getLayoutETag(options) {
        const storageKey = _StorageKeyCache.get(options);
        const layoutJson = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Layout, storageKey);
        if (layoutJson)
            return JSON.parse(layoutJson).localEtag || "";
        return "";
    }
    static updateColumnSize(options, gridColumns) {
        const storageKey = _StorageKeyCache.get(options);
        let layoutJson = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Layout, storageKey);
        if (layoutJson) {
            let layout = JSON.parse(layoutJson).layoutJSON;
            LayoutStorage.migrateColumnFormat(layout, false);
            gridColumns.forEach(function (currentColumn) {
                if (currentColumn.field !== "resizeDummy") {
                    let colIdx = layout.columns.findIndex(x => x.dataField === FieldNameConverter_1.FieldNameConverter.fromInternalName(currentColumn.field));
                    if (colIdx >= 0 && typeof currentColumn.width === "number")
                        layout.columns[colIdx].width = currentColumn.width;
                }
            });
            LayoutStorage.SaveLayout(storageKey, layout);
        }
    }
    static updateColumnOrder(options, oldIndex, newIndex) {
        const storageKey = _StorageKeyCache.get(options);
        let layoutJson = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Layout, storageKey);
        if (layoutJson) {
            let layout = JSON.parse(layoutJson).layoutJSON;
            LayoutStorage.migrateColumnFormat(layout, false);
            let tmpColumn = layout.columns[oldIndex];
            layout.columns.splice(oldIndex, 1);
            layout.columns.splice(newIndex, 0, tmpColumn);
            LayoutStorage.SaveLayout(storageKey, layout);
        }
    }
    static updateColumnSort(options, fieldName, direction) {
        const storageKey = _StorageKeyCache.get(options);
        let layoutJson = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Layout, storageKey);
        if (layoutJson) {
            let layout = JSON.parse(layoutJson).layoutJSON;
            ;
            LayoutStorage.migrateColumnFormat(layout, false);
            for (let i = 0; i < layout.columns.length; i++) {
                if (layout.columns[i].dataField === fieldName)
                    layout.columns[i].sortDirection = direction;
                else
                    layout.columns[i].sortDirection = undefined;
            }
            LayoutStorage.SaveLayout(storageKey, layout);
        }
    }
    static SaveLayout(key, layout) {
        const layoutCopy = $.extend(true, {}, layout);
        LayoutStorage.migrateColumnFormat(layoutCopy, true);
        let layoutData = {
            localEtag: Utilities_1.synUtil.getGUID(true),
            layoutJSON: layoutCopy,
        };
        LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Layout, key, JSON.stringify(layoutData), true);
    }
    static migrateColumnFormat(colLayout, oldFormat) {
        colLayout.columns.forEach((col) => {
            const anyCol = col;
            if (oldFormat) {
                if (col.dataField) {
                    anyCol.datafield = col.dataField;
                    delete col.dataField;
                }
                if (typeof col.isFtField !== "undefined") {
                    anyCol.isFTField = col.isFtField;
                    delete col.isFtField;
                }
                if (col.title) {
                    anyCol.text = col.title;
                    delete col.title;
                }
                if (col.sortDirection) {
                    anyCol.sortDir = col.sortDirection;
                    delete col.sortDirection;
                }
            }
            else {
                if (anyCol.datafield) {
                    col.dataField = anyCol.datafield;
                    delete anyCol.datafield;
                }
                if (typeof anyCol.isFTField !== "undefined") {
                    col.isFtField = anyCol.isFTField;
                    delete anyCol.isFTField;
                }
                if (anyCol.text) {
                    col.title = anyCol.text;
                    delete anyCol.text;
                }
                if (anyCol.sortDir) {
                    col.sortDirection = anyCol.sortDir;
                    delete anyCol.sortDir;
                }
            }
        });
    }
}
exports.LayoutStorage = LayoutStorage;
